import { useContext, } from 'react';
import { Card, Field } from '../../../../layouts';
import { PurchaseOrderContext } from '../context/PurchaseOrderContext';

export default function CustomerInformationCard() {

	const { order } = useContext(PurchaseOrderContext);

	return (
		<>
			<Card
				header={'Customer Information'}
				className="field-label-35"
			>
				<Field label={'Name'} >{order.details.retailOrder.customerName}</Field>
				<Field label={'Address'} >{order.details.retailOrder.customerAddress1}</Field>
				<Field label={''} visible={!!order.details.retailOrder.customerAddress2} >{order.details.retailOrder.customerAddress2}</Field>
				<Field label={'City'} >{order.details.retailOrder.customerCityZip}</Field>
				<Field label={'Phone'} >{order.details.retailOrder.customerPhone}</Field>
				<Field label={'Alternate Phone'} visible={!!order.details.retailOrder.customerAlternatePhone}>
					{order.details.retailOrder.customerAlternatePhone}
				</Field>
				<Field label={'Email'} >
					<a href={'mailto:' + order.details.retailOrder.customerEmail}>
						{order.details.retailOrder.customerEmail}
					</a>
				</Field>
			</Card>
		</>
	);
}
